import { Injectable } from '@angular/core';
import { InitDevService } from './dev.interface';

@Injectable({
  providedIn: 'root'
})
export class BlankDevService extends InitDevService {
  async init(): Promise<void> {
    // no-op
  }

  throwProductionError() {
    // no-op
  }
}
